import axios from "axios";
import * as settingType from "../../types/admin/settingType";

//Setting Idle time
export const userIdIdleAction =
  (userId, departId, formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_IDLE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        formData,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/idle/${userId}/${departId}`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_IDLE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_IDLE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Idle time
export const userIdIdleTimeAction =
  (userId, idleTime) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_IDLE_TIME_LIMIT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        idleTime,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/idletime/${userId}`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_IDLE_TIME_LIMIT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_IDLE_TIME_LIMIT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Screenshot
export const userIdScreenShotAction =
  (ssTime, userId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_SCREENSHOT_LIMIT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        ssTime,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/screenshot/${userId}/`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_SCREENSHOT_LIMIT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_SCREENSHOT_LIMIT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Weekly Limit
export const userIdWeeklyLimitAction =
  (weeklyLimit, userId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_WEEKLY_LIMIT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let body = {
        weeklyLimit,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/weekly/${userId}/`,
        body,
        config
      );
      // console.log(data?.data);
      dispatch({
        type: settingType.ADD_WEEKLY_LIMIT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_WEEKLY_LIMIT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting notification
export const AddNotifcationAction =
  (notification) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_NOTIFICATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        notification,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/notify/company/all/user`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_NOTIFICATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_NOTIFICATION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting type
export const AddUserTypeAction = (type) => async (dispatch, getState) => {
  try {
    dispatch({
      type: settingType.ADD_COMPANY_TYPE_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    const body = {
      type,
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/type/company/`,
      body,
      config
    );
    // console.log(data);
    dispatch({
      type: settingType.ADD_COMPANY_TYPE_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: settingType.ADD_COMPANY_TYPE_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Get Setting Of Company
export const getSettingForCompanyAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: settingType.GET_DATA_Of_USER_SETTING_BY_COMPANY_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/company/`,
      config
    );
    // console.log(data);
    dispatch({
      type: settingType.GET_DATA_Of_USER_SETTING_BY_COMPANY_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: settingType.GET_DATA_Of_USER_SETTING_BY_COMPANY_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Get Setting Of Department
export const getSettingForDepartmentAction =
  (departId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/department/${departId}`,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Time hero
export const userIdTimeHeroAction =
  (timeHero, userId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_TIMEHERO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const body = {
        timeHero,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/timehero/${userId}`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_TIMEHERO_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_TIMEHERO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Company Setting
export const AddCompanySettingAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: settingType.ADD_COMPANY_SETTING_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0){
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/department/setting/company`,
      {},
      config
    );
    // console.log(data);
    dispatch({
      type: settingType.ADD_COMPANY_SETTING_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: settingType.ADD_COMPANY_SETTING_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Setting Company All Idle time
export const companyIdleTimeAction =
  (idleTime) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_IDLE_TIME_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        idleTime,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/idletime/company/all/user`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_IDLE_TIME_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_IDLE_TIME_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Company All ScreenShot
export const companyScreenShotAction =
  (ssTime) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_SCREENSHOT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        ssTime,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/screenshot/company/all/user`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_SCREENSHOT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_SCREENSHOT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Company All Weekly limit
export const companyWeeklyLimitAction =
  (weeklyLimit) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        weeklyLimit,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/weekly/company/all/user`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Company All Time Hero
export const companyTimeHeroAction =
  (timeHero) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_TIME_HERO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        timeHero,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/timehero/company/all/user`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_TIME_HERO_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_TIME_HERO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get company setting
export const getCompanySettingAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: settingType.GET_COMPANY_SETTING_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/companysetting`,
      config
    );
    dispatch({
      type: settingType.GET_COMPANY_SETTING_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: settingType.GET_COMPANY_SETTING_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Setting Company All ScreenShot
export const companyAppTrackAction =
  (appTrack) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_APP_TRACK_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        appTrack,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/apptrack/company/all/user`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_APP_TRACK_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_ALL_COMPANY_USERS_APP_TRACK_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting App Track
export const userIdAppTrackAction =
  (appTrack, userId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_APP_TRACK_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        appTrack,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/apptrack/${userId}`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_APP_TRACK_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_APP_TRACK_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Pay Rate
export const userIdPayRateAction =
  (payRate, userId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_PAY_RATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const body = {
        payRate,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/payrate/${userId}`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_PAY_RATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_PAY_RATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Pay Rate
export const companyWorkingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_WORKING_COMPANY_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/working/company/all/user/`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_WORKING_COMPANY_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_WORKING_COMPANY_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Working Policy
export const addcompanyWorkingPolicyAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_COMPANY_WORKING_POLICY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/working/company/policy/`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_COMPANY_WORKING_POLICY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_COMPANY_WORKING_POLICY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Approve Setting Leave
export const addCompanyApproveSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_APPROVE_LEAVE_SETIING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/leave/approve/add`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_APPROVE_LEAVE_SETIING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_APPROVE_LEAVE_SETIING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Approve Setting Leave
export const addCompanyExcludeSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_EXCLUDE_LEAVE_SETIING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/leave/exclude/add`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_EXCLUDE_LEAVE_SETIING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_EXCLUDE_LEAVE_SETIING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Approve Setting Leave
export const addLeaveApproversCompanySettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_LEAVE_APPROVER_SETIING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/update/individual/leaves`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_LEAVE_APPROVER_SETIING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_LEAVE_APPROVER_SETIING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//updateOneFieldTemplate
export const updateOneCustomFieldAction =
  (formdata, templateId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.UPDATE_ONE_CUSTOM_FIELD_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/custom-field-temp/${templateId}/update-one-field`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.UPDATE_ONE_CUSTOM_FIELD_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.UPDATE_ONE_CUSTOM_FIELD_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Approve Company Setting Leave
export const addLeaveCompanyApproversSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_LEAVE_APPROVER_SETIING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/update/company/leaves`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_LEAVE_APPROVER_SETIING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_LEAVE_APPROVER_SETIING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//Add Approve Company Setting Expense
export const addExpenseCompanyApproversSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_EXPENSE_APPROVER_SETIING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/update/expense/approve-setting`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_EXPENSE_APPROVER_SETIING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_EXPENSE_APPROVER_SETIING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//Add Approve Setting Leave
export const addLeaveApproversSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_LEAVE_APPROVER_SETIING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/update/individual/leaves`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_LEAVE_APPROVER_SETIING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_LEAVE_APPROVER_SETIING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Payroll Component Of Company Setting
export const addCompanPayrollCompSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_COMPANY_PAYROLL_COMP_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/payroll/add`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_COMPANY_PAYROLL_COMP_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_COMPANY_PAYROLL_COMP_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get Payroll Component Of Company Setting
export const getCompanPayrollCompSettingAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.GET_COMPANY_PAYROLL_COMP_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/payroll/company/`,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.GET_COMPANY_PAYROLL_COMP_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.GET_COMPANY_PAYROLL_COMP_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Archived Payroll Component Of Company Setting
export const ArchivedCompanPayrollCompSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/payroll/archived`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Basic Payroll Component Of Company Setting
export const addCompanyBasicPayrollCompSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_COMPANY_BASIC_PAYROLL_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/payroll/basic/add`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_COMPANY_BASIC_PAYROLL_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_COMPANY_BASIC_PAYROLL_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Archived Salary Component Of Company Setting
export const ArchivedCompanSalaryCompSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ARCHIVED_COMPANY_SALARY_COMP_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/salary/update`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ARCHIVED_COMPANY_SALARY_COMP_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ARCHIVED_COMPANY_SALARY_COMP_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Documents Setting For Company
export const addDocumentCompanySettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_COMPANY_DOCUMENT_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/mandtory/document/company`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_COMPANY_DOCUMENT_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_COMPANY_DOCUMENT_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Basic Salary Component Of Company Setting
export const addCompanyBasicSalaryCompSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_COMPANY_SALARY_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/salary/add`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_COMPANY_SALARY_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_COMPANY_SALARY_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Salary Component Of Company Setting
export const addCompSalaryCompSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_COMP_SALARY_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/salary/add`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_COMP_SALARY_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_COMP_SALARY_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Delete Salary Component Of Company Setting
export const deleteCompSalaryCompSettingAction =
  (id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.DELETE_COMP_SALARY_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/salary/${id}/delete`,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.DELETE_COMP_SALARY_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.DELETE_COMP_SALARY_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Archived Tax Component Of Company Setting
export const ArchivedCompanyTaxSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ARCHIVED_COMPANY_TAX_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/taxes/archived`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ARCHIVED_COMPANY_TAX_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ARCHIVED_COMPANY_TAX_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Active Tax Component Of Company Setting
export const ActiveCompanyTaxSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_ACTIVE_COMPANY_TAX_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/taxes/active`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_ACTIVE_COMPANY_TAX_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_ACTIVE_COMPANY_TAX_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Tax Component Of Company Setting
export const addCompanyTaxSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_COMPANY_TAX_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/taxes/create`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_COMPANY_TAX_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_COMPANY_TAX_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Leave Reason Of Company Setting
export const addCompanyReasonLeaveSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_REASON_LEAVE_SETIING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/update/company/leaves/reason`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_REASON_LEAVE_SETIING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_REASON_LEAVE_SETIING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Leave Calender Of Company Setting
export const addCompanyCalenderLeaveSettingAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ADD_LEAVE_CALENDER_SETIING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/update/company/leaves/calender`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ADD_LEAVE_CALENDER_SETIING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ADD_LEAVE_CALENDER_SETIING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//getAllBulkImports
export const getAllBulkImportsAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: settingType.GET_ALL_BULK_IMPORTS_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/bulk-employee/get-all`,

      config
    );
    // console.log(data);
    dispatch({
      type: settingType.GET_ALL_BULK_IMPORTS_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: settingType.GET_ALL_BULK_IMPORTS_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//getAllCustomFieldTemplate
export const getAllCustomFieldTemplateAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.GET_ALL_CUSTOM_FIELD_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/custom-field-temp/get-all`,

        config
      );
      // console.log(data);
      dispatch({
        type: settingType.GET_ALL_CUSTOM_FIELD_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.GET_ALL_CUSTOM_FIELD_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//createCustomFieldTemplate
export const createCustomFieldTemplateAction =
  (formdata) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.CREATE_CUSTOM_FIELD_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/custom-field-temp/update-create`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.CREATE_CUSTOM_FIELD_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.CREATE_CUSTOM_FIELD_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//deleteCustomFieldTemplate
export const deleteCustomFieldTemplateAction =
  (templateId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.DELETE_CUSTOM_FIELD_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/custom-field-temp/${templateId}/delete-one-field`,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.DELETE_CUSTOM_FIELD_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.DELETE_CUSTOM_FIELD_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//archiveCompanyAttendanceStatuses
export const archiveCompanyAttendanceStatusesAction =
  (formData, id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ARCHIVE_COMPANY_ATTENDANCE_STATUSES_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/company-attendance/${id}/status`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ARCHIVE_COMPANY_ATTENDANCE_STATUSES_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ARCHIVE_COMPANY_ATTENDANCE_STATUSES_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const archiveUserAttendanceStatusesAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.ARCHIVE_USER_ATTENDANCE_STATUSES_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/company-attendance/statusId/user-status`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.ARCHIVE_USER_ATTENDANCE_STATUSES_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.ARCHIVE_USER_ATTENDANCE_STATUSES_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//getAllCompanyAttendanceStatuses
export const getAllCompanyAttendanceStatusesAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.GET_ALL_COMPANY_STATUSES_ATTENDANCE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/company-attendance/get-all`,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.GET_ALL_COMPANY_STATUSES_ATTENDANCE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.GET_ALL_COMPANY_STATUSES_ATTENDANCE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//getAllUserAttendanceStatuses
export const getAllUserAttendanceStatusesAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.GET_ALL_USER_STATUSES_ATTENDANCE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/company-attendance/users-get`,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.GET_ALL_USER_STATUSES_ATTENDANCE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.GET_ALL_USER_STATUSES_ATTENDANCE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//updateCompanyAttendanceStatuses
export const updateCompanyAttendanceStatusesAction =
  (formData, id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.UPDATE_COMPANY_ATTENDANCE_STATUSES_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/company-attendance/${id}/update`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.UPDATE_COMPANY_ATTENDANCE_STATUSES_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.UPDATE_COMPANY_ATTENDANCE_STATUSES_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//createCompanyAttendanceStatuses
export const createCompanyAttendanceStatusesAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.CREATE_COMPANY_ATTENDANCE_STATUSES_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/company-attendance/create`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.CREATE_COMPANY_ATTENDANCE_STATUSES_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.CREATE_COMPANY_ATTENDANCE_STATUSES_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//contactSupport
export const contactSupportAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.CONTACT_SUPPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/contact-support/create`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.CONTACT_SUPPORT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.CONTACT_SUPPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//contactSupportEmail
export const contactSupportEmailAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingType.CONTACT_SUPPORT_EMAIL_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/contact-support/create`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingType.CONTACT_SUPPORT_EMAIL_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingType.CONTACT_SUPPORT_EMAIL_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
